import {notifyError, stopNotifyLoading} from "./modal.js";
import React from 'react';
import axios from 'axios';

function fetchJson(url, data, options={}) {
    // return fetchWrapper(url, data, options, false);
    return axiosWrapper(url, data, options, false);
}

function fetchJsonNoModals(url, data, options={}) {
    // return fetchWrapper(url, data, options, true);
    return axiosWrapper(url, data, options, true);
}

const errors = {
    cancelline: "Sorry, we are currently unable to cancel this order.",
    wrong: "Sorry, something went wrong",
    forbidden: "Forbidden",
};

const messages = {
    cancelline: <>Please contact our customer services team by <a href="mailto:customerservices@peters.co.uk">email</a> or telephone <a href="tel:+4401216666646">0121 666 6646</a>.</>,
    wrong: <>Please <a href="/report-a-problem" target="_blank">report the problem here</a>.</>,
    forbidden: <>Please contact your IT support about whitelisting the peters.co.uk domain</>
};

function axiosWrapper(url, data, options, noModals) {
    return axios.post(url, data, options)
        .then(r => {
            if (r.data.error) {
                return handleError(noModals, r.data.error);
            }
            return r.data;
        })
        .catch(e => {
            if (e.response) {
                const status = e.response.status;
                const json = e.response.data;
                var error = (json && json.error) || e.response.statusText;
                var message = "";
                if (json.error && errors[json.error]) {
                    error = errors[json.error];
                }
                if (json.error && messages[json.error]) {
                    message = messages[json.error];
                }
                if (status >= 400 && status < 500) {
                    if (error == "Forbidden" && !message && status == 403) {
                        message = messages['forbidden'];
                    }
                    return handleError(noModals, error, message);
                } else {
                    error = errors.wrong;
                    message = messages.wrong;

                    return handleError(noModals, error, message, json ? json.error : "Unknown error");
                }
            } else {
                console.log(e);
                if (e.heading) { // we generated that error in handleError
                    return Promise.reject(e);
                }
                // if (e.name === 'AbortError') {
                //     return;
                // }
                // something else went wrong but we won't do anything because it might just be the user changing pages
                // console.error(e.message);
                // return handleError(noModals, 'Unexpected error', messages.wrong);
            }
        });
}

/** wraps the fetch API. data can be an object (which is converted to JSON), or a FormData object */
function fetchWrapper(url, data, options, noModals) {
    var body;
    if (data !== null) {
        body = JSON.stringify(data);
    }
    if (data instanceof FormData) {
        body = data;
    }
    options.body = body;
    if (!options.method) {
        options.method = "POST";
    }
    if (!options.signal) {
        const controller = new AbortController();
        options.signal = controller.signal;
    }

    return fetch(url, options).then(response => {
        if (!response.ok) {
            return response.json().then(json => {
                var error = (json && json.error) || response.statusText;
                var message = "";
                if (json.error && errors[json.error]) {
                    error = errors[json.error];
                }
                if (json.error && messages[json.error]) {
                    message = messages[json.error];
                }
                // Bad request - show the error message to the user
                if (response.status >= 400 && response.status < 500) {
                    return handleError(noModals, error, message);
                } else { // server error
                    if (json) {
                        // console.error(json.error);
                    }
                    error = errors.wrong;
                    message = messages.wrong;

                    return handleError(noModals, error, message, json ? json.error : "Unknown error");
                }
            })
        }
        return response.json().then(json => {
            // the response returned a success code but there is an error message
            if (json.error) {
                return handleError(noModals, json.error);
            }
            return json;
        });
    }).catch(reason => { // JavaScript or network error
        if (reason.heading) { // we generated that error in handleError
            return Promise.reject(reason);
        }
        if (reason.name === 'AbortError') {
            return;
        }
        // if (reason == "TypeError: NetworkError when attempting to fetch resource.") {
            // probably the user was just changing pages. In future we should use abortable fetch
            // return;
        // }
        return handleError(noModals, "Network error", <>Please <a href="/report-a-problem" target="_blank">report the problem here</a>.</>, reason);
    });
}

function handleError(noModals, heading, message, error) {
    if (!noModals) {
        stopNotifyLoading();
        notifyError(heading, message);
    }
    // allow handling the error in a custom way with a catch block
    return Promise.reject({
        error: error,
        heading: heading,
        message: message
    });
}

export {fetchJsonNoModals, fetchJson};